import styled from 'styled-components';

export const NavItemStyle = styled.div`
  width: 100%;
  .entry {
    cursor: pointer;
    list-style: none;
    /* height: 56px; */
    margin: 8px 6px;
    text-align: center;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    color: #212d51;
    &:hover {
      background: #f7fafc;
    }
    .name {
      margin-top: 8px;
    }
  }
`;

export const NavIconItemStyle = styled.div`
  width: 100%;
  .entry {
    cursor: pointer;
    list-style: none;
    /* height: 56px; */
    margin: 0 6px;
    padding: 8px 0px;
    text-align: center;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    line-height: 1;
    color: #212d51;
    &:hover {
      background-color: rgba(24, 144, 255, 0.05);
    }
    .name {
      margin-top: 8px;
    }
  }
`;
